module.exports = __webpack_public_path__ + "static/media/dice_logo.4d28e064.png";